import React, { useState, useEffect } from "react";
import "./table.css";
import Loading from "./Loading.js";
import url from "../constants/URL";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroller";

const Reviews = (props) => {
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState([]);
  const [allLoaded, setAllLoaded] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const token = await JSON.parse(localStorage.getItem("persist:auth")).token;

    fetch(`${url}/shop/reviews/${props.auth.seller._id}/?skip=${reviews.length}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then(async (resp) => {
      const data = await resp.json();
      if (data.length < 10) {
        setAllLoaded(true);
      }
      if (reviews.length === 0) {
        setReviews(data);
        setLoading(false);
      } else {
        setReviews([...data, ...reviews]);
        setLoadingMore(false);
      }
    });
  };

  const loadMoreItems = () => {
    setLoadingMore(true);
    fetchData();
  };

  if (loading) {
    return <Loading />;
  }
  if (!loading && reviews.length === 0) {
    return <div>No Reviews Yet</div>;
  }
  return (
    <div className="container">
      <p style={{ marginLeft: 20, fontSize: 24 }}>Customer's Reviews</p>
      <hr />
      <div className="table_container">
        <table>
          <tr>
            <th className="table_head">Number</th>
            <th className="table_head">Product Name</th>
            <th className="table_head">Buyer Name</th>
            <th className="table_head">Date</th>
            <th className="table_head">Ratings</th>
            <th className="table_head">Review</th>
          </tr>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (!loadingMore) {
                loadMoreItems();
              }
            }}
            hasMore={!allLoaded}
            threshold={8}
            style={{ display: "table-row-group" }}
          >
            {reviews.map((item, key) => {
              return (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.reviewBy.name}</td>
                  <td>{new Date(item.review.reviewAt).toLocaleDateString()}</td>
                  <td>{item.review.rating}</td>
                  <td>{item.review.review}</td>
                </tr>
              );
            })}
          </InfiniteScroll>
        </table>
      </div>
      {loadingMore && (
        <div>
          <h3
            style={{ color: "green", textAlign: "center", paddingBottom: 30 }}
          >
            Loading More...
          </h3>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Reviews);
